import ImageWithFallback from '@/components/common/image-with-fallback'
import DiscordIcon from '@/components/icons/logos/discord'
import { Button } from '@/components/ui/button'
import { htmlClassName, normalizeHtml } from '@/helpers/html'
import { cn } from '@/lib/utils'
import Link from 'next/link'
import SessionCarousel from './session-carousel'

export default function DetailsSection({ event, isSingleEvent, params }) {
  // ensure discord links begins with https://discord.gg/
  let discordLink = null
  if (event.championship.community.joinLinkService === 'discord-server') {
    discordLink = event.championship.community.joinLinkUrl
    if (discordLink && !discordLink.startsWith('https://discord.gg/')) {
      discordLink = `https://discord.gg/${discordLink}`
    }
  }

  return (
    <div className="font-inter">
      <div className="mt-6 desktop-xs:mt-12" />
      <SessionCarousel event={event} selectedSplits={[]} params={params} />

      <div className="screen-grid mt-6 desktop-xs:mt-12">
        <div className="divide grid-indent h-px bg-neutral-blue-700" />

        <div className="grid-indent mb-[51px] mt-8 grid gap-y-10 desktop-xs:mb-[100px] desktop-xs:mt-[60px] desktop-xs:grid-cols-10 desktop-xs:gap-x-4 desktop-sm:gap-x-6 desktop-md:gap-x-7 desktop-lg:gap-x-8">
          <div
            className={cn(
              htmlClassName,
              'wrap-break-word col-span-full max-w-full overflow-hidden desktop-xs:col-span-7',
            )}
            dangerouslySetInnerHTML={{
              __html: event.championship.descriptionHtml
                ? normalizeHtml(event.championship.descriptionHtml)
                : isSingleEvent
                  ? 'No description has been added to this event.'
                  : 'No description has been added to this championship.',
            }}
          ></div>

          {discordLink && (
            <div className="col-span-full flex h-fit flex-col gap-5 rounded-lg border border-neutral-blue-700 bg-neutral-blue-800 px-4 py-[26px] desktop-xs:col-span-3 desktop-xs:px-10 desktop-xs:py-[36px]">
              <div className="relative mx-auto size-7 overflow-hidden rounded-md bg-neutral-blue-100/20 desktop-xs:size-10">
                <ImageWithFallback
                  alt=""
                  className="object-cover"
                  src={event.championship.community.logoImgUrl}
                  fill
                />
              </div>
              <h5 className="text-center text-h-6 font-semibold desktop-xs:text-h-5">
                Join {event.championship.community.name} Discord
              </h5>
              <Button
                variant="outline"
                asChild
                className="w-full! border-neutral-blue-600! bg-[#5B65EA]! text-white! hover:bg-[#444cb3]! mx-auto mt-5 flex h-fit flex-nowrap items-center gap-[9px] rounded-sm px-4 py-5 align-middle font-inter font-semibold tablet:mb-4 tablet:ml-auto tablet:mr-0 tablet:mt-auto tablet:w-fit tablet:py-4"
              >
                <Link
                  href={discordLink}
                  target="_blank"
                  className="w-full text-center tablet:w-auto"
                >
                  <DiscordIcon className="mr-2 inline-block size-5 fill-white" />{' '}
                  Join Discord
                </Link>
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
